<template>
  <div>
    <div style="margin-left: 30px" class="text-danger">
      如欲修改，建議於營業時間結束後修改全國接單控管時段設定，避免影響現行門市接單計算，謝謝
    </div>

    <b-card class="bg-default-card" :header="brandName">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <label class="col-md-7 control-label"
              >平日最後點餐時間：營業時間結束前/分鐘</label
            >
            <div class="col-md-4">
              <input
                type="number"
                class="form-control"
                placeholder="請輸入數值"
                min="5"
                max="60"
                v-model="WeekdayLastOrderTime"
                :disabled="!setActivity"
              />
              <div class="text-danger" v-if="valid_WeekdayLastOrderTime">{{ valid_WeekdayLastOrderTime }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <label class="col-md-7 control-label"
              >假日最後點餐時間：營業時間結束前/分鐘</label
            >
            <div class="col-md-4">
              <input
                type="number"
                class="form-control"
                placeholder="請輸入數值"
                min="5"
                max="60"
                v-model="HolidayLastOrderTime"
                :disabled="!setActivity"
              />
              <div class="text-danger" v-if="valid_HolidayLastOrderTime">{{ valid_HolidayLastOrderTime }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <label class="col-md-7 control-label">時段控量間隔分鐘：</label>
            <div class="col-md-4">
              <input
                v-model="PeriodIntervalTime"
                type="number"
                class="form-control"
                :min="PeriodIntervalTime_min"
                :max="PeriodIntervalTime_max"
                :disabled="!setActivity"
              />
              <div class="text-danger" v-if="valid_PeriodIntervalTime">{{ valid_PeriodIntervalTime }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <label class="col-md-7 control-label">備餐時間：</label>
            <div class="col-md-4">
              <input
                v-model="MakeMealTime"
                type="number"
                class="form-control"
                :min="MakeMealTime_min"
                :max="MakeMealTime_max"
                :disabled="!setActivity"
              />
              <div class="text-danger" v-if="valid_MakeMealTime">{{ valid_MakeMealTime }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <label class="col-md-7 control-label">時段可接單金額：</label>
            <div class="col-md-4">
              <input
                v-model="PeriodAmount"
                type="number"
                class="form-control"
                :min="PeriodAmount_min"
                :max="PeriodAmount_max"
                :disabled="!setActivity"
              />
              <div class="text-danger" v-if="valid_PeriodAmount">{{ valid_PeriodAmount }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <label class="col-md-7 control-label">允許接單金額超出額度：</label>
            <div class="col-md-4">
              <input
                v-model="OverAmount"
                type="number"
                class="form-control"
                :min="OverAmount_min"
                :max="OverAmount_max"
                :disabled="!setActivity"
              />
              <div class="text-danger" v-if="valid_OverAmount">{{ valid_OverAmount }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-7"></div>
            <div class="col-md-4 text-right pt-2">
              <button
                type="button"
                class="btn btn-warning btnByEdit"
                v-show="!setActivity"
                @click="edit"
                v-if="FunctionPermission > 1"
              >
                編輯
              </button>
              <button
                type="button"
                class="btn btn-save"
                v-show="setActivity"
                @click="confirm"
              >
                儲存
              </button>
              <button
                type="button"
                class="btn btn-clear"
                v-show="setActivity"
                @click="cancel"
              >
                取消
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-card>

    <!--Double Check Modal -->
    <b-modal ref="mdCheck" hide-footer title="全國接單設定">
      <b-container fluid>
        <form>
          <div class="row mb-3">
            <label class="control-label">確定儲存 ?</label>
          </div>
          <div class="float-right">
            <b-btn variant="primary" @click="chkSave">確定</b-btn>
            <b-btn variant="secondary" @click="chkCancel">取消</b-btn>
          </div>
        </form>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { getFunctionPermission } from "@/js/LoginUserFunction.js";
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
export default {
  props: {
    brandCode: {
      type: String,
      default: "",
    },
    brandName: {
      type: String,
      default: "",
    },
    weekdayLastOrderTime: {
      type: String,
      default: "",
    },
    holidayLastOrderTime: {
      type: String,
      default: "",
    },
    periodIntervalTime: {
      type: String,
      default: "",
    },
    makeMealTime: {
      type: String,
      default: "",
    },
    periodAmount: {
      type: String,
      default: "",
    },
    overAmount: {
      type: String,
      default: "",
    },
    setActivity: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      FunctionPermission: "",
      PeriodIntervalTime_min: 5,
      PeriodIntervalTime_max: 30,
      PeriodAmount_min: 5,
      PeriodAmount_max: 5000,
      OverAmount_min: 0,
      OverAmount_max: 2000,
      MakeMealTime_min: 5,
      MakeMealTime_max: 30,
      WeekdayLastOrderTime:this.weekdayLastOrderTime,
      HolidayLastOrderTime:this.holidayLastOrderTime,
      PeriodIntervalTime:this.periodIntervalTime,
      PeriodAmount:this.periodAmount,
      OverAmount:this.overAmount,
      MakeMealTime:this.makeMealTime,
      valid_errMsg: false,
      valid_WeekdayLastOrderTime: '',
      valid_HolidayLastOrderTime: '',
      valid_PeriodIntervalTime: '',
      valid_MakeMealTime: '',
      valid_PeriodAmount: '',
      valid_OverAmount: '',
    };
  },
  created() {
    this.FunctionPermission = getFunctionPermission("F20"); // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: "name" });
      return;
    }
  },
  methods: {
    edit() {
      this.$emit("edit");
    },
    confirm() {
      this.valid_errMsg = false;
      var numReg = /^[-+]?[0-9]+$/;
      var numRe = new RegExp(numReg);
      var numWeekTime = Number(this.WeekdayLastOrderTime);
      var numHolidayTime = Number(this.HolidayLastOrderTime);

      if (
        !this.WeekdayLastOrderTime ||
        numWeekTime < 5 ||
        numWeekTime > 60 ||
        numWeekTime % 5 !== 0
      ) {
        this.valid_errMsg = true;
        this.valid_WeekdayLastOrderTime = "請輸入數值5~60，請為5的倍數";
      } else {
        this.valid_WeekdayLastOrderTime = "";
      }
      if (
        !this.HolidayLastOrderTime ||
        numHolidayTime < 5 ||
        numHolidayTime > 60 ||
        numHolidayTime % 5 !== 0
      ) {
        this.valid_errMsg = true;
        this.valid_HolidayLastOrderTime = "請輸入數值5~60，請為5的倍數";
      } else {
        this.valid_HolidayLastOrderTime = "";
      }
      if (!this.PeriodIntervalTime) {
        this.valid_errMsg = true;
        this.valid_PeriodIntervalTime = "必填";
      } else if (!numRe.test(this.PeriodIntervalTime)) {
        this.valid_errMsg = true;
        this.valid_PeriodIntervalTime = "請輸入數字";
      } else if (
        this.PeriodIntervalTime < this.PeriodIntervalTime_min ||
        this.PeriodIntervalTime > this.PeriodIntervalTime_max
      ) {
        this.valid_errMsg = true;
        this.valid_PeriodIntervalTime =
          "請輸入" +
          this.PeriodIntervalTime_min +
          "~" +
          this.PeriodIntervalTime_max;
      } else {
        this.valid_PeriodIntervalTime = "";
      }
      if (!this.MakeMealTime) {
        this.valid_errMsg = true;
        this.valid_MakeMealTime = "必填";
      } else if (!numRe.test(this.MakeMealTime)) {
        this.valid_errMsg = true;
        this.valid_MakeMealTimee = "請輸入數字";
      } else if (
        this.MakeMealTime < this.MakeMealTime_min ||
        this.MakeMealTime > this.MakeMealTime_max
      ) {
        this.valid_errMsg = true;
        this.valid_MakeMealTime =
          "請輸入" + this.MakeMealTime_min + "~" + this.MakeMealTime_max;
      } else if (this.MakeMealTime % 5 != 0) {
        this.valid_errMsg = true;
        this.valid_MakeMealTime = "請以5分鐘為單位";
      } else {
        this.valid_MakeMealTime = "";
      }
      if (!this.PeriodAmount) {
        this.valid_errMsg = true;
        this.valid_PeriodAmount = "必填";
      } else if (!numRe.test(this.PeriodAmount)) {
        this.valid_errMsg = true;
        this.valid_PeriodAmount = "請輸入數字";
      } else if (
        this.PeriodAmount < this.PeriodAmount_min ||
        this.PeriodAmount > this.PeriodAmount_max
      ) {
        this.valid_errMsg = true;
        this.valid_PeriodAmount =
          "請輸入" + this.PeriodAmount_min + "~" + this.PeriodAmount_max;
      } else {
        this.valid_PeriodAmount = "";
      }
      if (!this.OverAmount) {
        this.valid_errMsg = true;
        this.valid_OverAmount = "必填";
      } else if (!numRe.test(this.OverAmount)) {
        this.valid_errMsg = true;
        this.valid_OverAmount = "請輸入數字";
      } else if (
        this.OverAmount < this.OverAmount_min ||
        this.OverAmount > this.OverAmount_max
      ) {
        this.valid_errMsg = true;
        this.valid_OverAmount =
          "請輸入" + this.OverAmount_min + "~" + this.OverAmount_max;
      } else {
        this.valid_OverAmount = "";
      }
      if (this.valid_errMsg) {
        this.$parent.$parent.verificationErrMsg();
        return;
      }
      this.$refs.mdCheck.show();
      this.$emit("confirm");
    },
    cancel() {
      this.WeekdayLastOrderTime = this.weekdayLastOrderTime
      this.HolidayLastOrderTime = this.holidayLastOrderTime
      this.PeriodIntervalTime = this.periodIntervalTime
      this.PeriodAmount = this.periodAmount
      this.OverAmount = this.overAmount
      this.MakeMealTime = this.makeMealTime
      this.valid_WeekdayLastOrderTime = ''
      this.valid_HolidayLastOrderTime = ''
      this.valid_PeriodIntervalTime = ''
      this.valid_MakeMealTime = ''
      this.valid_PeriodAmount = ''
      this.valid_OverAmount = ''
      this.$emit("cancel");
    },
    chkCancel () {
      this.$refs.mdCheck.hide()
      this.$emit("chkCancel");
    },
    chkSave () {
      this.$refs.mdCheck.hide()

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/mealOrderSettingUpdate/v1', {
        brandCode: this.BrandCode,
        weekdayLastOrderTime: this.WeekdayLastOrderTime,
        holidayLastOrderTime: this.HolidayLastOrderTime,
        periodIntervalTime: this.PeriodIntervalTime,
        makeMealTime: this.MakeMealTime,
        periodAmount: this.PeriodAmount,
        
        overAmount: this.OverAmount
      })
      .then((response) => {
        this.$store.commit('TOKEN', response.data.jwt)

        if (response.data.result === '0000') {
          miniToastr.success('儲存成功')
          this.$emit("chkSave");
        } else if (response.data.result === '0006') {
          this.$parent.logOut(true, true)
        } else {
          miniToastr.error(response.data.message, '資料變更錯誤')
          console.log(response.data.message)
          this.cancel()
        }
      })
      .catch((error) => {
        miniToastr.error(error, '資料變更錯誤')
        console.log(error)
        this.cancel()
      })
      .finally(() => {
        this.set_activity = false
        this.$parent.Loading = false
      })
    },
  },
  watch:{
    weekdayLastOrderTime:{
      handler(val){
        this.WeekdayLastOrderTime = val
      },immediate:true
    },
    holidayLastOrderTime:{
      handler(val){
        this.HolidayLastOrderTime = val
      },immediate:true
    },
    periodIntervalTime:{
      handler(val){
        this.PeriodIntervalTime = val
      },immediate:true
    },
    makeMealTime:{
      handler(val){
        this.MakeMealTime = val
      },immediate:true
    },
    periodAmount:{
      handler(val){
        this.PeriodAmount = val
      },immediate:true
    },
    overAmount:{
      handler(val){
        this.OverAmount = val
      },immediate:true
    },
    setActivity:{
      handler(val){
        this.SetActivity = val
      },immediate:true
    },
    brandCode:{
      handler(val){
        this.BrandCode = val
      },immediate:true
    },
    brandName:{
      handler(val){
        this.BrandName = val
      },immediate:true
    },
  }
};
</script>

<style scoped>
.btnByEdit,
.btnByEdit:active,
.btnByEdit:focus {
  color: #fff !important;
  background-color: #519b39 !important;
  border-color: #519b39 !important;
}

.btnByEdit:hover {
  color: #fff !important;
  background-color: #138045 !important;
  border-color: #138045 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/ordersetting/OrderControlSettingItem.vue